<template>
  <svg
    class="footer-icon purple"
    width="91"
    height="121"
    viewBox="0 0 91 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1770_1346)">
      <path
        d="M88.2358 29.9305C86.0325 35.4814 81.806 39.8142 76.2774 42.1304L41.2235 56.7862C34.3329 59.901 28.7844 65.9111 26.1203 73.1791C25.6996 74.3371 25.3791 75.4952 25.0987 76.6733C21.7335 74.8363 18.7289 72.3404 16.3052 69.2256C19.9908 59.4617 27.5024 51.415 36.997 47.1221L72.1711 32.4064C75.0355 31.2084 77.2389 28.9522 78.3807 26.0769C79.5024 23.2017 79.4223 20.0668 78.1403 17.2515C78.0402 17.0319 77.94 16.8122 77.8198 16.6125L87.2944 11.9203C87.4747 12.2198 87.6349 12.5592 87.7751 12.8787C90.259 18.3297 90.4192 24.3797 88.2358 29.9305Z"
        fill="url(#paint0_linear_1770_1346)" />
      <path
        d="M88.8567 84.3606L79.2419 88.7733L79.1818 88.6335C77.9198 85.8581 75.6563 83.7616 72.812 82.6833C69.9676 81.6251 66.8628 81.7249 64.0986 82.9828L54.5439 87.2957C49.436 89.6119 44.0477 90.7101 38.7395 90.7101C33.9922 90.7101 29.3251 89.8116 24.9183 88.1543C20.9321 86.6568 17.1664 84.5003 13.8412 81.7649C9.6548 78.3305 6.14941 73.9578 3.68562 68.8063C-0.741191 59.5616 -1.2019 49.0589 2.38362 39.2751C6.00919 29.3515 13.6009 21.165 23.1956 16.8322L59.2711 1.73713C69.9676 -2.73548 82.0662 1.73713 87.2943 11.9203C87.4745 12.2198 87.6348 12.5592 87.775 12.8787L82.9676 15.0751L78.1402 17.2515C78.04 17.0318 77.9398 16.8122 77.8197 16.6125C75.0754 11.4211 68.8659 9.18482 63.3574 11.4611L27.4422 26.4962C20.5516 29.6111 14.983 35.6211 12.3189 42.8891C9.71489 49.9974 10.0554 57.5848 13.2403 64.2538C14.1016 66.0508 15.1432 67.7081 16.305 69.2256C18.7288 72.3404 21.7334 74.8363 25.0986 76.6733C32.6101 80.7465 41.8844 81.4454 50.1771 77.6916L59.7318 73.3787C65.06 70.9427 71.0493 70.763 76.5377 72.8196C81.8459 74.8163 86.1124 78.6899 88.5762 83.7616C88.6563 83.9213 88.7365 84.101 88.8166 84.2607C88.8366 84.3007 88.8366 84.3206 88.8567 84.3606Z"
        fill="#BDCBFF" />
      <path
        d="M82.3266 121V116.807H81.0647V115.908H84.7103V116.807H83.4484V121H82.3266ZM85.3513 121V115.928H87.0339L87.4145 117.126C87.6749 118.025 88.0554 119.383 88.1957 119.802C88.2958 119.383 88.5963 118.245 88.9368 117.146L89.3174 115.928H91V121H89.9383V118.824C89.9383 118.284 89.9584 117.226 89.9584 116.827H89.9383C89.8582 117.086 89.6379 117.905 89.3975 118.624L88.6363 121.02H87.6348L86.8736 118.584C86.7334 118.105 86.493 117.266 86.3929 116.887H86.3729C86.3729 117.286 86.3929 117.905 86.3929 118.624V121.02H85.3313L85.3513 121Z"
        fill="#BDCBFF" />
      <path
        d="M77.8799 113.273L68.3452 117.586C63.2373 119.902 57.8491 121 52.5409 121C38.0386 121 24.0571 112.853 17.4669 99.0962C14.8429 93.6253 13.6611 87.715 13.8414 81.7649C17.1665 84.5003 20.9323 86.6568 24.9184 88.1543C25.3591 90.3507 26.0401 92.4871 27.0216 94.5437C33.5517 108.221 50.1372 114.231 63.9585 107.982L73.5132 103.669C79.242 101.073 81.7859 94.3241 79.1819 88.6335L88.8167 84.2607C88.8968 84.4404 88.9769 84.6401 89.0571 84.8198C93.6642 95.7018 88.7366 108.361 77.8799 113.273Z"
        fill="url(#paint1_linear_1770_1346)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1770_1346"
        x1="49.5"
        y1="45"
        x2="20"
        y2="73.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#BDCBFF" />
        <stop
          offset="1"
          stop-color="#BDCBFF"
          stop-opacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1770_1346"
        x1="54"
        y1="115"
        x2="23.5"
        y2="88.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#BDCBFF" />
        <stop
          offset="1"
          stop-color="#BDCBFF"
          stop-opacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_1770_1346">
        <rect
          width="91"
          height="121"
          fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    class="footer-icon yellow"
    width="91"
    height="121"
    viewBox="0 0 91 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1782_1587)">
      <path
        d="M88.2358 29.9305C86.0325 35.4814 81.806 39.8142 76.2774 42.1304L41.2235 56.7862C34.3329 59.901 28.7844 65.9111 26.1203 73.1791C25.6996 74.3371 25.3791 75.4952 25.0987 76.6733C21.7335 74.8363 18.7289 72.3404 16.3052 69.2256C19.9908 59.4617 27.5024 51.415 36.997 47.1221L72.1711 32.4064C75.0355 31.2084 77.2389 28.9522 78.3807 26.0769C79.5024 23.2017 79.4223 20.0668 78.1403 17.2515C78.0402 17.0319 77.94 16.8122 77.8198 16.6125L87.2944 11.9203C87.4747 12.2198 87.6349 12.5592 87.7751 12.8787C90.259 18.3297 90.4192 24.3797 88.2358 29.9305Z"
        fill="url(#paint0_linear_1782_1587)" />
      <path
        d="M88.8567 84.3606L79.2419 88.7733L79.1818 88.6335C77.9198 85.8581 75.6563 83.7616 72.812 82.6833C69.9676 81.6251 66.8628 81.7249 64.0986 82.9828L54.5439 87.2957C49.436 89.6119 44.0477 90.7101 38.7395 90.7101C33.9922 90.7101 29.3251 89.8116 24.9183 88.1543C20.9321 86.6568 17.1664 84.5003 13.8412 81.7649C9.6548 78.3305 6.14941 73.9578 3.68562 68.8063C-0.741191 59.5616 -1.2019 49.0589 2.38362 39.2751C6.00919 29.3515 13.6009 21.165 23.1956 16.8322L59.2711 1.73713C69.9676 -2.73548 82.0662 1.73713 87.2943 11.9203C87.4745 12.2198 87.6348 12.5592 87.775 12.8787L82.9676 15.0751L78.1402 17.2515C78.04 17.0318 77.9398 16.8122 77.8197 16.6125C75.0754 11.4211 68.8659 9.18482 63.3574 11.4611L27.4422 26.4962C20.5516 29.6111 14.983 35.6211 12.3189 42.8891C9.71489 49.9974 10.0554 57.5848 13.2403 64.2538C14.1016 66.0508 15.1432 67.7081 16.305 69.2256C18.7288 72.3404 21.7334 74.8363 25.0986 76.6733C32.6101 80.7465 41.8844 81.4454 50.1771 77.6916L59.7318 73.3787C65.06 70.9427 71.0493 70.763 76.5377 72.8196C81.8459 74.8163 86.1124 78.6899 88.5762 83.7616C88.6563 83.9213 88.7365 84.101 88.8166 84.2607C88.8366 84.3007 88.8366 84.3206 88.8567 84.3606Z"
        fill="#FFC200" />
      <path
        d="M82.3266 121V116.807H81.0647V115.908H84.7103V116.807H83.4484V121H82.3266ZM85.3513 121V115.928H87.0339L87.4145 117.126C87.6749 118.025 88.0554 119.383 88.1957 119.802C88.2958 119.383 88.5963 118.245 88.9368 117.146L89.3174 115.928H91V121H89.9383V118.824C89.9383 118.284 89.9584 117.226 89.9584 116.827H89.9383C89.8582 117.086 89.6379 117.905 89.3975 118.624L88.6363 121.02H87.6348L86.8736 118.584C86.7334 118.105 86.493 117.266 86.3929 116.887H86.3729C86.3729 117.286 86.3929 117.905 86.3929 118.624V121.02H85.3313L85.3513 121Z"
        fill="#FFC200" />
      <path
        d="M77.8799 113.273L68.3452 117.586C63.2373 119.902 57.8491 121 52.5409 121C38.0386 121 24.0571 112.853 17.4669 99.0962C14.8429 93.6253 13.6611 87.715 13.8414 81.7649C17.1665 84.5003 20.9323 86.6568 24.9184 88.1543C25.3591 90.3507 26.0401 92.4871 27.0216 94.5437C33.5517 108.221 50.1372 114.231 63.9585 107.982L73.5132 103.669C79.242 101.073 81.7859 94.3241 79.1819 88.6335L88.8167 84.2607C88.8968 84.4404 88.9769 84.6401 89.0571 84.8198C93.6642 95.7018 88.7366 108.361 77.8799 113.273Z"
        fill="url(#paint1_linear_1782_1587)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1782_1587"
        x1="49.5"
        y1="45"
        x2="20"
        y2="73.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC200" />
        <stop
          offset="1"
          stop-color="#FFC200"
          stop-opacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1782_1587"
        x1="54"
        y1="115"
        x2="23.5"
        y2="88.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC200" />
        <stop
          offset="1"
          stop-color="#FFC200"
          stop-opacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_1782_1587">
        <rect
          width="91"
          height="121"
          fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    class="footer-icon green"
    width="91"
    height="121"
    viewBox="0 0 91 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1770_1351)">
      <path
        d="M88.2358 29.9305C86.0325 35.4814 81.806 39.8142 76.2774 42.1304L41.2235 56.7862C34.3329 59.901 28.7844 65.9111 26.1203 73.1791C25.6996 74.3371 25.3791 75.4952 25.0987 76.6733C21.7335 74.8363 18.7289 72.3404 16.3052 69.2256C19.9908 59.4617 27.5024 51.415 36.997 47.1221L72.1711 32.4064C75.0355 31.2084 77.2389 28.9522 78.3807 26.0769C79.5024 23.2017 79.4223 20.0668 78.1403 17.2515C78.0402 17.0319 77.94 16.8122 77.8198 16.6125L87.2944 11.9203C87.4747 12.2198 87.6349 12.5592 87.7751 12.8787C90.259 18.3297 90.4192 24.3797 88.2358 29.9305Z"
        fill="url(#paint0_linear_1770_1351)" />
      <path
        d="M88.8567 84.3606L79.2419 88.7733L79.1818 88.6335C77.9198 85.8581 75.6563 83.7616 72.812 82.6833C69.9676 81.6251 66.8628 81.7249 64.0986 82.9828L54.5439 87.2957C49.436 89.6119 44.0477 90.7101 38.7395 90.7101C33.9922 90.7101 29.3251 89.8116 24.9183 88.1543C20.9321 86.6568 17.1664 84.5003 13.8412 81.7649C9.6548 78.3305 6.14941 73.9578 3.68562 68.8063C-0.741191 59.5616 -1.2019 49.0589 2.38362 39.2751C6.00919 29.3515 13.6009 21.165 23.1956 16.8322L59.2711 1.73713C69.9676 -2.73548 82.0662 1.73713 87.2943 11.9203C87.4745 12.2198 87.6348 12.5592 87.775 12.8787L82.9676 15.0751L78.1402 17.2515C78.04 17.0318 77.9398 16.8122 77.8197 16.6125C75.0754 11.4211 68.8659 9.18482 63.3574 11.4611L27.4422 26.4962C20.5516 29.6111 14.983 35.6211 12.3189 42.8891C9.71489 49.9974 10.0554 57.5848 13.2403 64.2538C14.1016 66.0508 15.1432 67.7081 16.305 69.2256C18.7288 72.3404 21.7334 74.8363 25.0986 76.6733C32.6101 80.7465 41.8844 81.4454 50.1771 77.6916L59.7318 73.3787C65.06 70.9427 71.0493 70.763 76.5377 72.8196C81.8459 74.8163 86.1124 78.6899 88.5762 83.7616C88.6563 83.9213 88.7365 84.101 88.8166 84.2607C88.8366 84.3007 88.8366 84.3206 88.8567 84.3606Z"
        fill="#0F2C29" />
      <path
        d="M82.3266 121V116.807H81.0647V115.908H84.7103V116.807H83.4484V121H82.3266ZM85.3513 121V115.928H87.0339L87.4145 117.126C87.6749 118.025 88.0554 119.383 88.1957 119.802C88.2958 119.383 88.5963 118.245 88.9368 117.146L89.3174 115.928H91V121H89.9383V118.824C89.9383 118.284 89.9584 117.226 89.9584 116.827H89.9383C89.8582 117.086 89.6379 117.905 89.3975 118.624L88.6363 121.02H87.6348L86.8736 118.584C86.7334 118.105 86.493 117.266 86.3929 116.887H86.3729C86.3729 117.286 86.3929 117.905 86.3929 118.624V121.02H85.3313L85.3513 121Z"
        fill="#0F2C29" />
      <path
        d="M77.8799 113.273L68.3452 117.586C63.2373 119.902 57.8491 121 52.5409 121C38.0386 121 24.0571 112.853 17.4669 99.0962C14.8429 93.6253 13.6611 87.715 13.8414 81.7649C17.1665 84.5003 20.9323 86.6568 24.9184 88.1543C25.3591 90.3507 26.0401 92.4871 27.0216 94.5437C33.5517 108.221 50.1372 114.231 63.9585 107.982L73.5132 103.669C79.242 101.073 81.7859 94.3241 79.1819 88.6335L88.8167 84.2607C88.8968 84.4404 88.9769 84.6401 89.0571 84.8198C93.6642 95.7018 88.7366 108.361 77.8799 113.273Z"
        fill="url(#paint1_linear_1770_1351)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1770_1351"
        x1="49.5"
        y1="45"
        x2="20"
        y2="73.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#0F2C29" />
        <stop
          offset="1"
          stop-color="#0F2C29"
          stop-opacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1770_1351"
        x1="54"
        y1="115"
        x2="23.5"
        y2="88.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#0F2C29" />
        <stop
          offset="1"
          stop-color="#0F2C29"
          stop-opacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_1770_1351">
        <rect
          width="91"
          height="121"
          fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    class="footer-icon gray"
    width="91"
    height="121"
    viewBox="0 0 91 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1782_1571)">
      <path
        d="M88.2358 29.9305C86.0325 35.4813 81.806 39.8142 76.2774 42.1304L41.2235 56.7861C34.3329 59.901 28.7844 65.9111 26.1203 73.179C25.6996 74.3371 25.3791 75.4952 25.0987 76.6733C21.7335 74.8363 18.7289 72.3404 16.3052 69.2256C19.9908 59.4617 27.5024 51.415 36.997 47.1221L72.1711 32.4064C75.0355 31.2084 77.2389 28.9521 78.3807 26.0769C79.5024 23.2016 79.4223 20.0668 78.1403 17.2515C78.0402 17.0318 77.94 16.8122 77.8198 16.6125L87.2944 11.9203C87.4747 12.2198 87.6349 12.5592 87.7751 12.8787C90.259 18.3297 90.4192 24.3797 88.2358 29.9305Z"
        fill="url(#paint0_linear_1782_1571)" />
      <path
        d="M88.8567 84.3606L79.2419 88.7733L79.1818 88.6335C77.9198 85.8581 75.6563 83.7616 72.812 82.6834C69.9676 81.6251 66.8628 81.725 64.0986 82.9829L54.5439 87.2957C49.436 89.6119 44.0477 90.7101 38.7395 90.7101C33.9922 90.7101 29.3251 89.8116 24.9183 88.1543C20.9321 86.6568 17.1664 84.5004 13.8412 81.7649C9.6548 78.3306 6.14941 73.9578 3.68562 68.8063C-0.741191 59.5616 -1.2019 49.0589 2.38362 39.2751C6.00919 29.3515 13.6009 21.165 23.1956 16.8322L59.2711 1.73716C69.9676 -2.73545 82.0662 1.73716 87.2943 11.9203C87.4745 12.2198 87.6348 12.5593 87.775 12.8787L82.9676 15.0751L78.1402 17.2515C78.04 17.0319 77.9398 16.8122 77.8197 16.6126C75.0754 11.4212 68.8659 9.18485 63.3574 11.4611L27.4422 26.4962C20.5516 29.6111 14.983 35.6212 12.3189 42.8891C9.71489 49.9974 10.0554 57.5849 13.2403 64.2538C14.1016 66.0509 15.1432 67.7081 16.305 69.2256C18.7288 72.3405 21.7334 74.8363 25.0986 76.6733C32.6101 80.7466 41.8844 81.4454 50.1771 77.6916L59.7318 73.3787C65.06 70.9428 71.0493 70.7631 76.5377 72.8197C81.8459 74.8164 86.1124 78.69 88.5762 83.7616C88.6563 83.9213 88.7365 84.101 88.8166 84.2608C88.8366 84.3007 88.8366 84.3207 88.8567 84.3606Z"
        fill="#FFF8E3" />
      <path
        d="M82.3266 121V116.807H81.0647V115.908H84.7103V116.807H83.4484V121H82.3266ZM85.3513 121V115.928H87.0339L87.4145 117.126C87.6749 118.025 88.0554 119.383 88.1957 119.802C88.2958 119.383 88.5963 118.245 88.9368 117.146L89.3174 115.928H91V121H89.9383V118.824C89.9383 118.285 89.9584 117.226 89.9584 116.827H89.9383C89.8582 117.086 89.6379 117.905 89.3975 118.624L88.6363 121.02H87.6348L86.8736 118.584C86.7334 118.105 86.493 117.266 86.3929 116.887H86.3729C86.3729 117.286 86.3929 117.905 86.3929 118.624V121.02H85.3313L85.3513 121Z"
        fill="#FFF8E3" />
      <path
        d="M77.8799 113.273L68.3452 117.586C63.2373 119.902 57.8491 121 52.5409 121C38.0386 121 24.0571 112.854 17.4669 99.0962C14.8429 93.6253 13.6611 87.7151 13.8414 81.7649C17.1665 84.5004 20.9323 86.6568 24.9184 88.1543C25.3591 90.3507 26.0401 92.4872 27.0216 94.5438C33.5517 108.221 50.1372 114.231 63.9585 107.982L73.5132 103.669C79.242 101.073 81.7859 94.3241 79.1819 88.6335L88.8167 84.2608C88.8968 84.4405 88.9769 84.6401 89.0571 84.8198C93.6642 95.7019 88.7366 108.361 77.8799 113.273Z"
        fill="url(#paint1_linear_1782_1571)" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1782_1571"
        x1="49.5"
        y1="45"
        x2="20"
        y2="73.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFF8E3" />
        <stop
          offset="1"
          stop-color="#FFF8E3"
          stop-opacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1782_1571"
        x1="54"
        y1="115"
        x2="23.5"
        y2="88.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFF8E3" />
        <stop
          offset="1"
          stop-color="#FFF8E3"
          stop-opacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_1782_1571">
        <rect
          width="91"
          height="121"
          fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>

<style lang="scss">
.footer-icon {
  @apply w-full max-w-fit;
}
</style>
